import { render } from "./MainFooter.vue?vue&type=template&id=08d38ba6&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=08d38ba6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08d38ba6"

export default script